import { observer } from 'mobx-react-lite'
import previewImg from 'shared/assets/images/savedReplies/savedReplies_preview.png'
import { EmptyState, Typography } from 'shared/ui'
import { LINK_SAVED_REPLIES_GUIDE } from 'shared/constants/links'
import { getCDNAssetURL } from 'shared/lib'
import {
  CreateSavedRepliesButton,
  GuideSavedRepliesButton,
} from 'pages/settings/pages/savedReplies/ui/SavedRepliesAction'

import styles from './styles.module.scss'

export const SavedRepliesEmptyContent = observer(() => {
  return (
    <section className={styles.empty}>
      <EmptyState
        title={
          <span className={styles.title}>
            <a
              href={LINK_SAVED_REPLIES_GUIDE}
              rel='noreferrer'
              target='_blank'
              className={styles.titlePreview}
            >
              <img alt='Saved Replies preview' src={getCDNAssetURL(previewImg)} />
            </a>
            <Typography variant={'heading-lg'} ariaLabel='Saved replies'>
              Saved replies
            </Typography>
          </span>
        }
        actions={
          <div className={styles.actions}>
            <CreateSavedRepliesButton />
            <GuideSavedRepliesButton />
          </div>
        }
        text={<>Save time on common responses</>}
        typographyProps={{
          variant: 'body-lg-regular',
          ariaLabel: 'KnowledgeBaseText',
          marginTop: '4px',
        }}
        boxProps={{
          gap: '20px',
          width: 'unset',
          height: 'unset',
          textAlign: 'center',
        }}
        noIcon
      />
    </section>
  )
})
